import { createContext, useEffect, useState } from "react";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

export const CategoriasContext = createContext();

export const CategoriasProvider = ({ children }) => {
  const [categorias, setCategorias] = useState([]);
  const [cargaCat, setCargaCat] = useState(true);

  useEffect(() => {
    const fetchCategorias = async () => {
      try {
        const response = await axios.get(`${API_URL}/api/categorias/sepe`);
        setCategorias(response.data);
      } catch (err) {
        console.error("Error al obtener categorías:", err);
      } finally {
        setCargaCat(false);
      }
    };

    fetchCategorias();
  }, []);

  return (
    <CategoriasContext.Provider value={{ categorias, cargaCat}}>
      {children}
    </CategoriasContext.Provider>
  );
};
